const avenirRegular = require('./Avenir-Book.ttf')
const avenirMedium = require('./Avenir-Medium.ttf')
const avenirMediumObliquue = require('./Avenir-MediumOblique.ttf')
const avenirHeavy = require('./Avenir-Heavy.ttf')
const avenirHeavyObliquue = require('./Avenir-HeavyOblique.ttf')

export {
  avenirRegular,
  avenirHeavy,
  avenirHeavyObliquue,
  avenirMedium,
  avenirMediumObliquue,
}
